import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  helperRow: {
    height: '15px',
    fontFamily: 'Roboto',
    fontSize: '12px',
    display: 'flex',
    justifyContent: 'space-between',
  },
}));
